export default __webpack_public_path__ + "static/media/deleteblack.46454c8e.svg";